import { render, staticRenderFns } from "./onSubFormRowChange-editor.vue?vue&type=template&id=27461482&scoped=true&"
import script from "./onSubFormRowChange-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowChange-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27461482",
  null
  
)

export default component.exports